<main id="main-content" class="h-screen flex flex-col pl-8 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Threats & Hazards Goals and Objectives
                </h1>
                <div data-popover-target="popover-bottom" data-popover-placement="bottom" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-bottom" role="tooltip" class="absolute z-10 invisible inline-block w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2 flex flex-col gap-1">
                        <p>
                            Listed below are all of the threats and hazards identified in Step 2 as well as their associated vulnerability and risk assessments. For each threat or hazard, click on 
                            <span class="px-3.5 py-1 inline-flex font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer">
                                Edit
                            </span>. In the pop-up, fill out the specific goals and objectives for the threat/hazard. When all sections have been completed, click on 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>.
                        </p>
                        <p>
                            To preview goals and objectives, click on 
                            <span class="inline-flex px-3.5 py-1 font-normal oswald-font border border-nside-gray-400 bg-white rounded-md">
                                Preview
                            </span>.Note** this button will not be available until all goals and objectives have been completed for the threat/hazard. 
                        </p>
                        <p>
                            To delete goals and objectives for a threat/hazard, click on 
                            <span class="inline-flex px-3.5 py-1 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md"
                            >
                                Delete
                            </span>.Note** this button will not be available until all goals and objectives have been completed for the threat/hazard. This will only delete goals and objectives. This will not delete the threat/hazard.
                        </p>
                        <p>
                            Once completed, continue forward to create your <strong>Functional Assignments</strong>.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <eop-assistant
                [sectionId]="sectionTypeId"
            ></eop-assistant>        
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start gap-8 overflow-y-auto">
        <div class="max-h-full w-full flex flex-col items-center justify-center gap-4">
            <div class="h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col items-center justify-center p-6 gap-4">
                <ng-container *ngIf="threatsList.length > 0; else emptyThreat">
                    <div class="h-full w-full overflow-y-auto">
                        <table class="w-full text-left">
                            <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                                <tr>
                                    <th scope="col" class="h-12 px-4 py-3 py-3 w-10">
                                        <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            No.
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/6 px-4 py-3 w-32">
                                        <div (click)="$event.preventDefault(); sortList('threat')" class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            Threat or Hazard
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/6 px-4 py-3 min-w-32">
                                        <div (click)="$event.preventDefault(); sortList('probability')" class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            Probability
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/6 px-4 py-3">
                                        <div (click)="$event.preventDefault(); sortList('magnitude')" class="flex items-center justify-start gap-1 cursor-pointer">
                                            Magnitude
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/6 px-4 py-3">
                                        <div (click)="$event.preventDefault(); sortList('warning')" class="flex items-center justify-start gap-1 cursor-pointer">
                                            Warning
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/6 px-4 py-3">
                                        <div (click)="$event.preventDefault(); sortList('risk_priority')" class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            Risk Priority
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/6 px-4 py-3">
                                        <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            Actions
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let threat of threatsList | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;" class="bg-white border-b">
                                    <th scope="row" class="px-4 py-4">
                                        {{ i + 1 + (page - 1) * itemsPerPage }} 
                                    </th>
                                    <td class="px-4 py-4 font-medium whitespace-pre-line break-words [overflow-wrap:anywhere] align-top">
                                        <p class="w-full text-start">
                                          {{ threat.threat }}
                                        </p>
                                    </td>
                                    <td class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ threat.probability }}</p>
                                    </td>
                                    <td class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ threat.magnitude }}</p>
                                    </td>
                                    <td class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ threat.warning }}</p>
                                    </td>
                                    <td class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ threat.risk_priority }}</p>
                                    </td>
                                    <td class="px-4 py-4 font-medium flex gap-2">
                                        <button 
                                            (click)="$event.preventDefault(); handleOpenModal('threat-goal-details', threat);"
                                            class="w-full max-w-20 py-2 font-normal oswald-font border bg-white rounded-md"
                                            [ngClass]="{
                                                'border-gray-300 text-gray-300 cursor-not-allowed': !threat.goals || threat.goals.length === 0,
                                                'border-nside-gray-400 bg-white hover:bg-gray-100': threat.goals && threat.goals.length > 0
                                            }"
                                            [disabled]="!threat.goals || threat.goals.length === 0"
                                        >
                                            Preview
                                        </button>
                                        <button 
                                            *ngIf="canSave()"
                                            (click)="$event.preventDefault(); handleOpenModal('edit-threat-goal', threat);"                               
                                            class="w-full max-w-20 py-2 font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer"
                                        >
                                            Edit
                                        </button>
                                        <button 
                                            *ngIf="canSave()"
                                            (click)="$event.preventDefault(); handleOpenModal('delete-confirmation', threat);"
                                            class="w-full max-w-20 py-2 font-normal text-white oswald-font border  rounded-md"
                                            [ngClass]="{
                                                'border-gray-300 bg-gray-300 cursor-not-allowed': !threat.goals || threat.goals.length === 0,
                                                'border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200': threat.goals && threat.goals.length > 0
                                            }"
                                            [disabled]="!threat.goals || threat.goals.length === 0"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
                <ng-template #emptyThreat>
                    <div class="w-full text-nside-gray-100 italic text-start">
                        Empty list
                    </div>
                </ng-template>
                <div class="w-full flex justify-between items-center">
                    <p>{{ threatsList.length }} in total</p>
                    <pagination-controls
                        *ngIf="threatsList.length > itemsPerPage" 
                        (pageChange)="page = $event"
                        previousLabel="Prev"
                        nextLabel="Next"
                        class="mt-2"
                    ></pagination-controls>
                </div>
            </div>
        </div>
    </div>

    <introduction></introduction>

    <!-- Spinner -->
    <div *ngIf="loading">
        <spinner></spinner>
    </div>

    <threat-objectives-details
        *ngIf="showThreatObjectivesDetail"
        [threatGoals]="selectedThreat"
        (onClose)="handleCloseModal('threat-goal-details')"
    ></threat-objectives-details>

    <threat-objectives-edit
        *ngIf="showEditThreatObjectives"
        [threatToEdit]="selectedThreat"
        (onClose)="handleCloseModal('edit-threat-goal')"
        (onSave)="handleSave($event, 'edit-threat-goal')"
    ></threat-objectives-edit>

    <delete-confirmation
        *ngIf="showDeleteConfirmation"
        [text]="'this threat goals and objectives'"
        [itemToDelete]="selectedThreat"
        (onClose)="handleCloseModal('delete-confirmation')"
        (onDelete)="handleDelete($event)"
    ></delete-confirmation>

    <prv-next-buttons [totalPages]="(eopNavigationService.totalPages$ | async) || []" />

    <popup-message 
        [type]="messageModal"
        [message]="popupMessage"
        (close)="resetMessageModal()"
    ></popup-message>
</main>